import {labels as commonLabels, parseHtml} from "../../commons/commons";
import {JSX} from "wfr/commons/jsx"
import {ENavLanguages, L10nLabels, JDlInfos} from "../../commons/api";
import {urltree} from "./product";
import { styleSheet } from "wfr/commons/core";
import {lang} from "../../commons/language-selector";

export {DownloadLink}

const	labels:L10nLabels = {
	[ENavLanguages.fr]: {
		"0":"octets",
		"1":"Ko",
		"2":"Mo",
		"3":"Go",
		"rng":"Schéma RelaxNG",
		translation: (lang, percent)=>`${lang} traduit à ${percent}%`
	},
	[ENavLanguages.en]: {
		download:"Download",
		"0":"bytes",
		"1":"KB",
		"2":"MB",
		"3":"GB",
		"rng":"RelaxNG schema",
		translation: (lang, percent)=>`${lang} translated to ${percent}%`
	}
}

class DownloadLink extends HTMLElement {
	protected dl:JDlInfos
	protected norm_lang:string
	constructor(dl:JDlInfos) {
		super()
		this.dl = dl
		this.norm_lang = this.dl.metas.lang?.split("-")[0]
	}
	async connectedCallback() {
		this.attachShadow({mode: 'open'})
		this.shadowRoot!.adoptedStyleSheets.push(await styleSheet("./css/components.css"))

		const completion = this.dl.metas.translationCompletion && this.dl.metas.translationCompletion < 100
		if(this.dl.prc == "dlProduct") 	this.shadowRoot.append(
			<a href={`${urltree}${this.dl.metas.path}`}>
				<div class="label">
					{this.norm_lang != "all" ? <span class="lang" title={completion ? this.s("translation", this.s(`l10n_${this.norm_lang}`), this.dl.metas.translationCompletion) : this.s(`l10n_${this.norm_lang}`)}>
						{ completion ? <span class="translationCompletion" style={`width: ${this.dl.metas.translationCompletion}%`}></span> : null}
						<span class="lang-txt">{this.s(`l10n_${this.norm_lang}`)}</span></span> : null}
					<span class="label">{this.dl.n.endsWith(".rng.zip") ? this.s("rng"):this.dl.n}</span>
					<span class="size"> ({this.size(this.dl.s)})</span>
				</div>
				<div class="button">
					<span class="label">{this.s("download")}</span>
				</div>
			</a>);
		else this.shadowRoot.append(<div>
				<div class="olTitle">
					{this.norm_lang != "all" ? [<span>{this.s(`l10n_${this.norm_lang}`)}</span>, <span> </span>] : null}
					{this.dl.metas.locInfos[lang].title ? <span>{this.dl.metas.locInfos[lang].title}</span> : null}
				</div>
				{this.dl.metas.locInfos[lang].title ? <div class="olTitle">
				</div> : null}
				{this.dl.metas.locInfos[lang].body ? <div class="olContent">{parseHtml(this.dl.metas.locInfos[lang].body)}</div> : null}
			</div>)
	}

	protected size(s:number):string{
		let loop = 0;
		while (s > 1024){
			s = s/1024
			loop++
		}
		let norm_number:string
		if(s < 1) norm_number = s.toFixed(2)
		else if(s < 10) norm_number = s.toFixed(1)
		else norm_number = s.toFixed(0)
		return `${norm_number}${this.s(loop.toString())}`
	}

	protected s(key:string, ...args:any):string{
		if(key in commonLabels[lang]){
			if(typeof commonLabels[lang][key] == "function") return (commonLabels[lang][key] as (...args:any)=>string)(...args)
			else return commonLabels[lang][key] as string
		}

		if(typeof labels[lang][key] == "function") return (labels[lang][key] as (...args:any)=>string)(...args)
		else return labels[lang][key] as string
	}
}
customElements.define('download-link', DownloadLink)